/**
 * The OAuth consent screen's context, as returned by `GET consentInfo`.
 *
 * The DTO deliberately carries no `clientId` and no image field of any kind — the publisher mark is
 * a bundled asset keyed on `publisherHost`, never the client document's `logo_uri`.
 */
export type ConsentScope = {
  /** The raw scope string, e.g. `dl_mcp:read_only`. Rendered when `displayName` is absent. */
  name: string;
  displayName?: string;
  description?: string;
};

export type ConsentInfo = {
  /** Attacker-supplied; sanitized and capped server-side. Never inject as HTML. */
  clientName: string;
  /** Present only for a client whose `client_id` is an https URL. */
  publisherHost?: string;
  redirectUri: string;
  userDisplayName: string;
  scopes: ConsentScope[];
  /** Server-computed: whether to offer the "Remember my decision" checkbox. */
  canRemember: boolean;
};

export enum ConsentResponseCode {
  GRANTED = 'GRANTED',
  DENIED = 'DENIED',
  INVALID_REQUEST = 'INVALID_REQUEST',
}
